import { connect } from 'react-redux'
import _ from 'lodash'

import { getSortedVisibleLeagueIds, getSortedVisibleCategoryIds } from '../../selectors'
import { toggleCategory, addLeaguesWithPagination, openPopup, deleteCategory, updateCategory, updateCategoriesSimGolf } from '../../actions'
import CategoryListComponentSimGolf from '../../components/sim_golf/category_list_component_sim_golf'

const mapStateToProps = (state, props) => {
  const categoryIds = getSortedVisibleCategoryIds(state)
  const leagueIds = getSortedVisibleLeagueIds(state, props.id)
  const leagueNameFilterActive = !_.isEmpty(state.filters.leagueName)
  const opened = leagueNameFilterActive

  return {
    categoryIds,
    opened,
    leagueIds,
    userIsCustomerManager: state.misc.userIsCustomerManager,
    categories: state.categories,
    isSimGolf: state.misc.isSimGolf,
    customerId: state.misc.customerId,
  }
}

const mapDispatchToProps = (dispatch) => ({
  toggleCategory: (id) => dispatch(toggleCategory(id)),
  addLeaguesWithPagination: (id) => dispatch(addLeaguesWithPagination(id)),
  openPopup: (id, data) => dispatch(openPopup(id, data)),
  deleteCategory: (id) => dispatch(deleteCategory(id)),
  updateCategory: (data) => dispatch(updateCategory(data.id, data)),
  updateCategoriesSimGolf: (data) => dispatch(updateCategoriesSimGolf(data)),
  reorderCategories: (...params) => dispatch(reorderCategories(...params)),
  reorderLeagues: (...params) => dispatch(reorderLeagues(...params)),
  closeCategory: id => dispatch(closeCategory(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryListComponentSimGolf)
